/**
 * Do not edit directly
 * Generated on Tue, 04 Jun 2024 18:54:41 GMT
 */

export const breakpoints = {
podiumCdsBreakpointXs:"320px",
podiumCdsBreakpointS:"600px",
podiumCdsBreakpointM:"960px",
podiumCdsBreakpointL:"1440px",
podiumCdsBreakpointXl:"1920px",
}
